<template>
  <div class="row pt-5">
    <div class="col-md-6 col-lg-4">

      <!-- Copy the content below until next comment -->
      <div class="card card-custom">
        <div>
          <b-img class="img-fluid imgBorder" :src="require('../assets/shepa1.jpg')"/>
          <b-btn size="sm" variant="green" class="m-lg-n4 p-3">
            <b-icon icon="clock" aria-hidden="true"></b-icon>
            <router-link class="text-decoration-none font-weight-bold text-white" :to="{name:'Home'}">
              1 ماه پیش
            </router-link>
          </b-btn>
        </div>
        <div class="card-body">
          <h4 class="card-title">نحوه ساخت درگاه پرداخت اینترنتی</h4>
          <p class="card-text">یک فروشگاه اینترنتی وقتی کامل و آماده‌ی کسب درآمد میشود که به یک درگاه پرداخت
            اینترنتی معتبر و… </p>
        </div>

      </div>
      <!-- Copy until here -->

    </div>
    <div class="col-md-6 col-lg-4">

      <!-- Copy the content below until next comment -->
      <div class="card card-custom">
        <div>
          <b-img class="img-fluid imgBorder" :src="require('../assets/shepa2.jpg')"/>
          <b-btn size="sm" variant="green" class="m-lg-n4  p-3">
            <b-icon icon="clock" aria-hidden="true"></b-icon>
            <router-link class="text-decoration-none font-weight-bold text-white" :to="{name:'Home'}">
              1 ماه پیش
            </router-link>
          </b-btn>
        </div>

        <div class="card-body">
          <h4 class="card-title">نحوه دریافت درگاه اینترنتی</h4>
          <p class="card-text"> سرعت، امنیت و سهولت، اولین و اساسی‌ترین اصول کسب و کارهای اینترنتی است. وبسایت شما
            هم به این…</p>
        </div>
      </div>
      <!-- Copy until here -->
    </div>
    <div class="col-md-6 col-lg-4">
      <!-- Copy the content below until next comment -->
      <div class="card card-custom ">
        <div>
          <b-img class="img-fluid imgBorder" :src="require('../assets/shepa3.jpg')"/>
          <b-btn size="sm" variant="green" class="m-lg-n4  p-3">
            <b-icon icon="clock" aria-hidden="true"></b-icon>
            <router-link class="text-decoration-none font-weight-bold text-white" :to="{name:'Home'}">
              2 ماه پیش
            </router-link>
          </b-btn>
        </div>
        <div class="card-body" style="overflow-y: auto">
          <h4 class="card-title">درگاه پرداخت اینترنتی چیست ؟ | انواع درگاه پرداخت اینترنتی کدامند؟</h4>
          <p class="card-text">پیشرفت تکنولوژی باعث سهولت در انجام همه‌ی کارها شده است. یکی از کارهای مهم روزمره
            پرداخت‌های مالی هستند…</p>
        </div>
      </div>
      <!-- Copy until here -->
    </div>
  </div>
</template>

<script>
export default {
  name: "CardView"
}
</script>

<style scoped>

.btn-green {

  background: rgb(2, 137, 94);
  background: linear-gradient(0deg, rgba(2, 137, 94, 1) 0%, rgba(17, 220, 125, 1) 100%);
  color: #f1f5ff;
  border-radius: 20px;
  height: 60px;
}
.card-custom {
  border-radius: 20px;
  height: 500px;
  box-shadow: 0 0 15px rgba(10, 10, 10, 0.3);
}

.imgBorder {
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
}
</style>